"use client";

import dynamic from "next/dynamic";
import React, { useEffect } from "react";
import Sites from "../../constants/Sites";
import { useAppContext } from "@components/Provider";
import { useTabletDetection } from "helpers/useTabletDetection";
import NewsletterV2 from "../NewsletterV2/NewsletterV2";

import styles from "./HeaderWithLogoLayout.module.css";
import "./GlobalLayout1.css";
import TagManager from "react-gtm-module";
import ContentHeader from "@components/HeaderPage/ContentHeader";
import CatalogHeader from "@components/HeaderPage/CatalogHeader";

//Dynamic import based on https://github.com/zeit/next.js/blob/canary/examples/with-dynamic-import/pages/index.js
// {/ Load immediately, but in a separate bundle / }
const Header = dynamic(() => import("../Header/Header"));

const NewHeader = dynamic(() => import("../Header/NewHeader"), {
  ssr: false,
});

const HeaderWithLogoLayout = (props) => {
  const {
    siteId,
    isMobile,
    isTablet: serverIsTablet,
    subscriberCookie,
    tokenCookie,
    wasLoggedInCookie,
    isUserComingFromNL,
    isNonClosableModalChecked,
    data,
  } = useAppContext();

  // Enhanced client-side tablet detection using custom hook
  const { isTablet, isLargeTablet } = useTabletDetection(serverIsTablet, isMobile);

  let isHeader = siteId == Sites.EARLYBIRDBOOKS ? false : true;
  let hideHeader = data?.[0]?.Post?.post?.hide_header || false;

  useEffect(() => {
    if (!data?.SiteSettings?.gtm_container_id) return;

    // Delay GTM init until layout and page state are stable
    const id = data.SiteSettings.gtm_container_id;

    requestAnimationFrame(() => {
      TagManager.initialize({ gtmId: id });
    });
  }, [data?.SiteSettings?.gtm_container_id]);

  // Check if user is signed in or already subscribed
  const shouldHideNewsletter = 
    subscriberCookie || 
    tokenCookie || 
    wasLoggedInCookie || 
    isUserComingFromNL;
  const hideTopNewsletter = props?.hideTopNewsletter || false;

  return (
    <React.Fragment>
      {isHeader ? (
        <>
          <Header
            isNonClosableModalChecked={isNonClosableModalChecked}
            hideHeader={hideHeader}
          />
          {(!isMobile && !isTablet) && (
            siteId === Sites.OPENROADMEDIA ? <CatalogHeader /> : <ContentHeader isMobile={isMobile} isTablet={isTablet} />
          )}
        </>
      ) : (
        <NewHeader hideMenuItems={true} hideEBBNl={true} hideSearchBar={true} />
      )}
      {/* Mobile and tablet newsletter below header */}
      {!hideTopNewsletter && (isMobile || isTablet) && data?.SiteSettings?.newsletter_settings && !shouldHideNewsletter && (
        <div style={{ background: '#fff', padding: '24px 0 8px 0', display: 'flex', justifyContent: 'center' }}>
          <div style={{ width: '90%', maxWidth: 400 }}>
            <NewsletterV2
              isChild={true}
              Newsletter_Settings={data.SiteSettings.newsletter_settings}
              classNames={"headerNewsletter"}
              siteId={siteId}
              inlineStyles={{ button: { backgroundColor: '#333333' } }}
            />
          </div>
        </div>
      )}
      <div
        className={styles["container_headerWithLogo"]}
        style={{
          "--top-padding-1024": !subscriberCookie ? "58px" : isMobile ? "25px" : "48px",
          "--top-padding-712": !subscriberCookie ? siteId == Sites.EARLYBIRDBOOKS ? "0" : "15px" : "15px",
        }}
      >
        {props.children}
      </div>
    </React.Fragment>
  );
};

export default HeaderWithLogoLayout;
